export * from './DetailRow';
